import AppHeader from "../../layout/AppHeader";
import Contract from '../../xpost/views/register/contract/Contract.vue';
import ContractAdd from '../../xpost/views/register/contract/ContractAdd.vue';

const ContractRoutes = [
    {
        path: "/cadastro/contrato",
        name: "contract",
        components: {
            header: AppHeader,
            default: Contract,
        }
    },
    {
        path: "/cadastro/contrato/adicionar",
        name: "contract.add",
        components: {
            header: AppHeader,
            default: ContractAdd,
        }
    },
    {
        path: '/cadastro/contrato/adicionar/:id',
        name: 'contract.edit',
        components: {
            header: AppHeader,
            default: ContractAdd,
        }
    }
]

export default ContractRoutes;